@if (fileUpload | async; as upload) {
  @if (upload.status !== uploadStates.Canceled) {
    <div class="file-upload-item" [class]="'file-upload-item--' + fileOrder">
      <div class="file-upload-item__description">
        <div class="file-upload-item__name">
          {{ upload.file.name }}
        </div>
        <div
          class="file-upload-item__secondary-text"
          [class.file-upload-item__secondary-text--failure]="upload.status === uploadStates.Failure"
        >
          @switch (upload.status) {
            @case (uploadStates.Initializing) {
              Initializing upload
            }
            @case (uploadStates.Uploading) {
              Uploading {{ upload.progress | percent }}
            }
            @case (uploadStates.Scanning) {
              Scanning, please wait
            }
            @case (uploadStates.Finalizing) {
              Verifying upload
            }
            @case (uploadStates.Deleting) {
              Deleting
            }
            @case (uploadStates.Failure) {
              <ftr-icon icon="Error" size="Regular" color="Brand" gapRight="Regular" align="Middle"></ftr-icon>
              @if (isOverSizeLimit(upload)) {
                <span class="file-upload-item__error">
                  File size {{ upload.file.size | ftrFileSize }} is too large. Files must be smaller than
                  {{ sizeLimit | ftrFileSize }}.
                </span>
              } @else {
                <span class="file-upload-item__error">{{ upload.error }}</span>
              }
              <ng-template #error>
                <span class="file-upload-item__error">{{ upload.error }}</span>
              </ng-template>
            }
            @case (uploadStates.Success) {
              Uploaded {{ upload.label }}
            }
          }
        </div>
        @if (upload.status === uploadStates.Failure && isRetryEnabled(upload)) {
          <button type="button" class="file-upload-item__retry button button--text" (click)="retry(upload)">
            Retry
          </button>
        }
      </div>
      @if (isUploading(upload)) {
        <button
          ftrButton
          [displayType]="buttonDisplayType.Icon"
          type="button"
          class="file-upload-item__cancel file-upload-item__cancel--loader"
          (click)="cancelUpload(upload)"
        >
          <ftr-loader
            class="file-upload-item__loader"
            [iconOnly]="true"
            [isLoading]="true"
            [progress]="(upload.progress || 0) * 100"
            [fullPage]="true"
          ></ftr-loader>
          <ng-container *ngTemplateOutlet="cancel"></ng-container>
        </button>
      } @else {
        @if (isScanning(upload)) {
          <div class="file-upload-item__cancel file-upload-item__cancel--loader">
            <ftr-loader
              class="file-upload-item__loader"
              [iconOnly]="true"
              [isLoading]="true"
              [fullPage]="true"
            ></ftr-loader>
          </div>
        } @else {
          @if (isDeleting(upload)) {
            <div class="file-upload-item__cancel file-upload-item__cancel--loader">
              <ftr-loader
                class="file-upload-item__loader"
                [iconOnly]="true"
                [isLoading]="true"
                [fullPage]="true"
              ></ftr-loader>
            </div>
          } @else {
            <button
              ftrButton
              [displayType]="buttonDisplayType.Icon"
              type="button"
              class="file-upload-item__cancel"
              (click)="cancelUpload(upload)"
            >
              <ng-container *ngTemplateOutlet="cancel"></ng-container>
            </button>
          }
        }
      }
      <div
        class="file-upload-item__bar"
        [class.file-upload-item__bar--failure]="upload.status === uploadStates.Failure"
      ></div>
      <ng-template #cancel>
        <svg class="file-upload-item__cancel-icon" height="24" viewBox="0 0 24 24" width="24">
          <path
            d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
          />
          <path d="M0 0h24v24H0z" fill="none" />
        </svg>
      </ng-template>
    </div>
  }
}
